import _extends from '/app/node_modules/babel-runtime/helpers/extends';
import _regeneratorRuntime from '/app/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/app/node_modules/babel-runtime/helpers/asyncToGenerator';
import _defineProperty from '/app/node_modules/babel-runtime/helpers/defineProperty';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DateOption from './date-option';
import { mapMutations, mapState, mapActions } from 'vuex';

export default {
    components: {
        DateOption: DateOption
    },
    props: ['affiliationsStatus', 'tableName', 'conditional'],
    data: function data() {
        var _ref;

        return _ref = {
            items: ['manzana', 'pera'],
            product: '',
            dateOfAdmission: '',
            province: '',
            district: '',
            status: ''
        }, _defineProperty(_ref, 'product', this.$store.state.dashboard.table.product), _defineProperty(_ref, 'status', this.$store.state.dashboard.table.status), _defineProperty(_ref, 'sinceDate', this.$store.state.dashboard.table.sinceDate), _defineProperty(_ref, 'toDate', this.$store.state.dashboard.table.toDate), _defineProperty(_ref, 'monthYear', this.$store.state.dashboard.table.monthYear), _defineProperty(_ref, 'unlockProvince', false), _defineProperty(_ref, 'unlockDistrict', false), _defineProperty(_ref, 'department', ''), _defineProperty(_ref, 'departments', this.$store.getters['dashboard/filters/departments']), _defineProperty(_ref, 'districts', []), _defineProperty(_ref, 'provinces', []), _defineProperty(_ref, 'idDepartment', null), _defineProperty(_ref, 'idProvince', null), _defineProperty(_ref, 'productType', ''), _defineProperty(_ref, 'productsType', this.$store.getters['dashboard/filters/productsType']), _defineProperty(_ref, 'idProductType', null), _defineProperty(_ref, 'products', []), _defineProperty(_ref, 'idProduct', null), _defineProperty(_ref, 'unlockProductType', false), _defineProperty(_ref, 'typeOfSolution', ''), _defineProperty(_ref, 'typeOfSolutions', [{ text: 'Selección de producto', value: 0 }, { text: 'Validación de RUC/RUS', value: 1 }, { text: 'Datos del representante', value: 2 }, { text: 'Datos del Negocio', value: 3 }, { text: 'Horario de atención', value: 4 }, { text: 'Contactos del comercio', value: 5 }, { text: 'Datos de cuenta bancaria', value: 6 }, { text: 'Requisitos de afiliación', value: 7 }, { text: 'Tipo de Modalidad', value: 8 }, { text: 'Resumen de afiliación', value: 9 }, { text: 'Envío de términos', value: 10 }]), _defineProperty(_ref, 'statusItems', [{ text: 'Seleccione', value: -1 }, { text: 'Concretada', value: 2 }, { text: 'No Concretada', value: 1 }]), _ref;
    },
    created: function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
            return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (!this.department) {
                                _context.next = 4;
                                break;
                            }

                            _context.next = 3;
                            return this.findProvinceByDepartment({ idDepartment: this.department });

                        case 3:
                            this.provinces = _context.sent;

                        case 4:
                            this.province = '';
                            this.district = '';

                            if (!this.province) {
                                _context.next = 10;
                                break;
                            }

                            _context.next = 9;
                            return this.findDistrictByProvince({ idDepartment: this.department, idProvince: this.province });

                        case 9:
                            this.districts = _context.sent;

                        case 10:
                            this.district = '';

                            if (!this.productType) {
                                _context.next = 15;
                                break;
                            }

                            _context.next = 14;
                            return this.findProductByType({ idProductType: this.productType });

                        case 14:
                            this.products = _context.sent;

                        case 15:
                            this.product = '';

                        case 16:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function created() {
            return _ref2.apply(this, arguments);
        }

        return created;
    }(),

    methods: _extends({}, mapActions({
        findProvinceByDepartment: 'dashboard/filters/findProvinceByDepartment',
        findDistrictByProvince: 'dashboard/filters/findDistrictByProvince',
        findProductByType: 'dashboard/filters/findProductByType'
    }), {
        search: function search() {
            var _this = this;

            this.$nextTick(function () {
                _this.$store.commit('dashboard/table/setDashboardFilters', _this.$data);
                _this.$emit('input');
            });
        },
        dateOptionSelected: function dateOptionSelected(_ref3) {
            var sinceDate = _ref3.sinceDate,
                toDate = _ref3.toDate,
                monthYear = _ref3.monthYear;

            this.sinceDate = sinceDate;
            this.toDate = toDate;
            this.monthYear = monthYear;
            this.search();
        },
        clearFilters: function clearFilters() {
            this.productType = this.product = this.dateOfAdmission = this.department = this.province = this.district = this.status = this.sinceDate = this.toDate = this.monthYear = this.typeOfSolution = null;
            this.$store.commit('dashboard/table/cleanSetData', this.tableName);
            this.$store.dispatch('dashboard/table/search', {
                type: this.tableName
            });
            if (this.isInProcess) {
                this.$refs.dateOptionAdmin.clear();
            } else {
                this.$refs.dateOptionAdmin.clear();
                this.$refs.dateOptionHight.clear();
            }
        },
        selectDepartment: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(val) {
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                this.$store.commit('dashboard/filters/setIdDepartment', val);

                            case 1:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function selectDepartment(_x) {
                return _ref4.apply(this, arguments);
            }

            return selectDepartment;
        }(),
        selectProvince: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(val) {
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                this.$store.commit('dashboard/filters/setIdProvince', val);

                            case 1:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function selectProvince(_x2) {
                return _ref5.apply(this, arguments);
            }

            return selectProvince;
        }(),
        selectDistrict: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(val) {
                return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                this.$store.commit('dashboard/filters/setIdDistrict', val);

                            case 1:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function selectDistrict(_x3) {
                return _ref6.apply(this, arguments);
            }

            return selectDistrict;
        }(),
        selectProductType: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(val) {
                return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                this.$store.commit('dashboard/filters/setIdProductType', val);

                            case 1:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function selectProductType(_x4) {
                return _ref7.apply(this, arguments);
            }

            return selectProductType;
        }(),
        selectIdProduct: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(val) {
                return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                this.$store.commit('dashboard/filters/setIdProduct', val);

                            case 1:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function selectIdProduct(_x5) {
                return _ref8.apply(this, arguments);
            }

            return selectIdProduct;
        }(),
        selectTypeofSolution: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(val) {
                return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                this.$store.commit('dashboard/filters/setTypeofSolution', val);

                            case 1:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function selectTypeofSolution(_x6) {
                return _ref9.apply(this, arguments);
            }

            return selectTypeofSolution;
        }(),
        onSubmit: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
                var conditionalAdmision, conditionalHight, dataFilter;
                return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                conditionalAdmision = this.dashboardFilters.admisionStartDate !== '' && this.dashboardFilters.admisionEndDate === '' ? this.dashboardFilters.admisionStartDate : this.dashboardFilters.admisionEndDate;
                                conditionalHight = this.dashboardFilters.highStartDate !== '' && this.dashboardFilters.highEndDate === '' ? this.dashboardFilters.highStartDate : this.dashboardFilters.highEndDate;

                                try {
                                    dataFilter = {
                                        type: this.tableName,
                                        idProduct: Number(this.dashboardFilters.IdProduct) || -1,
                                        admisionStartDate: this.dashboardFilters.admisionStartDate || '',
                                        admisionEndDate: conditionalAdmision || '',
                                        highStartDate: this.dashboardFilters.highStartDate || '',
                                        highEndDate: conditionalHight || '',
                                        status: this.status || -1,
                                        idDepartament: Number(this.dashboardFilters.idDepartment) || -1,
                                        idProvince: Number(this.dashboardFilters.idProvince) || -1,
                                        idDistrict: Number(this.dashboardFilters.idDistrict) || -1,
                                        step: Number(this.dashboardFilters.idTypeOfSolution) || -1
                                    };

                                    this.$store.commit('dashboard/table/setDataFilter', dataFilter);

                                    this.$store.dispatch('dashboard/table/search', dataFilter);
                                } catch (error) {
                                    this.$controlMessage(error);
                                }
                                this.isActivator();

                            case 4:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function onSubmit() {
                return _ref10.apply(this, arguments);
            }

            return onSubmit;
        }(),
        dateAdmin: function dateAdmin() {
            this.$store.commit('dashboard/filters/setDate', 'date admission');
        },
        dateHight: function dateHight() {
            this.$store.commit('dashboard/filters/setDate', 'date hight');
        },
        isActivator: function isActivator() {
            var processActivator = this.$store.commit('dashboard/filters/setMenuActivatorTableProcess', false);
            var workedActivator = this.$store.commit('dashboard/filters/setMenuActivatorTableWorked', false);
            this.tableName == 'Work' ? workedActivator : processActivator;
        }
    }),
    watch: {
        department: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(id) {
                return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.findProvinceByDepartment({ departmentId: id });

                            case 2:
                                this.provinces = _context9.sent;

                                this.province = '';
                                this.district = '';

                            case 5:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function department(_x7) {
                return _ref11.apply(this, arguments);
            }

            return department;
        }(),
        province: function () {
            var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(id) {
                return _regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.findDistrictByProvince({ departmentId: this.department, provinceId: id });

                            case 2:
                                this.districts = _context10.sent;

                            case 3:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function province(_x8) {
                return _ref12.apply(this, arguments);
            }

            return province;
        }(),
        productType: function () {
            var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(id) {
                return _regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                _context11.next = 2;
                                return this.findProductByType({ productTypeId: id });

                            case 2:
                                this.products = _context11.sent;

                                this.product = '';

                            case 4:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function productType(_x9) {
                return _ref13.apply(this, arguments);
            }

            return productType;
        }()
    },
    computed: _extends({}, mapState({
        dashboardFilters: function dashboardFilters(state) {
            return state.dashboard.filters;
        }
    }), {
        isInProcess: function isInProcess() {
            return this.tableName === 'Process';
        }
    })
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dashboard/btn-filters.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/dashboard/btn-filters.vue
// module chunks = 0 5